/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
	  constructor() {
			super();

			this.tl = false;
			this.splittext = false;
	  }
		connectedCallback() {
			let _this = this;
			if ( document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				this.prepareAnimations();
			}
			// Video Support.
			let video_container = this.querySelector('.background-video__iframe');
			if ( video_container ) {
				if ( video_container.querySelector('iframe') ) {
					video_container.querySelector('iframe').onload = function() {
						_this.videoPlay(video_container);
					};
				}
				if ( video_container.querySelector('video') ) {
					this.setupHostedVideo(video_container.querySelector('video'));
				}
			}
		}
		disconnectedCallback() {
			if ( document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				this.tl.kill();
				this.splittext.revert();
			}
			if ( this.playHostedVideo ) {
				document.removeEventListener('touchstart', this.onFirstGesture);
				document.removeEventListener('click', this.onFirstGesture);
				window.removeEventListener('pageshow', this.playHostedVideo);
				document.removeEventListener('visibilitychange', this.onVisibilityChange);
			}
		}
		// iOS Safari needs muted + playsinline set as both attribute and property,
		// and silently rejects play() in Low Power Mode or after bfcache restore.
		setupHostedVideo(video) {
			video.muted = true;
			video.defaultMuted = true;
			video.playsInline = true;
			video.setAttribute('muted', '');
			video.setAttribute('playsinline', '');
			video.setAttribute('webkit-playsinline', '');
			video.setAttribute('autoplay', '');

			this.playHostedVideo = () => {
				if ( !video.paused ) return;
				let playPromise = video.play();
				if ( playPromise !== undefined ) {
					playPromise.catch((e) => console.log('Background video autoplay:', e));
				}
			};
			this.onFirstGesture = () => {
				this.playHostedVideo();
				document.removeEventListener('touchstart', this.onFirstGesture);
				document.removeEventListener('click', this.onFirstGesture);
			};
			this.onVisibilityChange = () => {
				if ( document.visibilityState === 'visible' ) this.playHostedVideo();
			};

			// Retry once the browser has enough data (first play() can fire too early)
			video.addEventListener('loadedmetadata', this.playHostedVideo, { once: true });
			video.addEventListener('canplay', this.playHostedVideo, { once: true });

			// Fallback for iOS Low Power Mode: autoplay is blocked until the first user gesture
			document.addEventListener('touchstart', this.onFirstGesture, { passive: true });
			document.addEventListener('click', this.onFirstGesture);

			// iOS Safari restores pages from bfcache with videos paused
			window.addEventListener('pageshow', this.playHostedVideo);
			document.addEventListener('visibilitychange', this.onVisibilityChange);

			this.playHostedVideo();
		}
		videoPlay(video_container) {
			setTimeout(() => {
				if (video_container.dataset.provider === 'youtube') {
					video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
				} else if (video_container.dataset.provider === 'vimeo') {
					video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
				}
			}, 10);
		}
		prepareAnimations() {
			let section = this,
					button_offset = 0;

			section.tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: "top center"
				}
			});

			document.fonts.ready.then(function() {
				section.splittext = new SplitText( section.querySelectorAll('h3, p'), {
						type: 'lines, words',
						linesClass: 'line-child'
					}
				);

				if ( section.querySelector('h3')) {
					let h3_duration = 0.7 + ( ( section.querySelectorAll('h3 .line-child div').length - 1 ) * 0.05 );
					section.tl
						.from( section.querySelectorAll('h3 .line-child div'), {
							duration: h3_duration,
							yPercent: '100',
							stagger: 0.05
						}, 0);
					button_offset += h3_duration;
				}
				if ( section.querySelector('p')) {
					let p_duration = 0.7 + ( ( section.querySelectorAll('p .line-child div').length - 1 ) * 0.02 );
					section.tl
						.from( section.querySelectorAll('p .line-child div'), {
							duration: p_duration,
							yPercent: '100',
							stagger: 0.02
						}, 0);
					button_offset += p_duration;
				}
				if ( section.querySelector('.video-lightbox-modal__button')) {
					section.tl
						.fromTo( section.querySelector('.video-lightbox-modal__button'), {
							autoAlpha: 0
						}, {
							duration: 0.5,
							autoAlpha: 1
						}, button_offset * 0.4);
				}

			});
		}
	}
	customElements.define('background-video', BackgroundVideo);
}
